import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../../hooks/useMetaPixel';
export const CHECKOUT_URL = 'https://pay.hotmart.com/P104435106G';
interface CTAButtonProps {
  children: React.ReactNode;
  showArrow?: boolean;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  showArrow = true,
  className = '',
  href = CHECKOUT_URL
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  const isCheckout = href === CHECKOUT_URL;
  const handleClick = () => {
    if (isCheckout) {
      trackPixelEvent('AddToCart', {
        content_name: 'Hook Arsenal',
        content_type: 'product',
        value: 17.0,
        currency: 'USD'
      });
    }
  };
  return <motion.a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={handleClick} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative inline-flex items-center justify-center gap-3
        bg-gradient-to-r from-accent to-accent-light
        text-white font-bold text-lg md:text-xl
        py-4 px-8 md:py-5 md:px-12
        rounded-xl
        animate-pulse-glow
        transition-all duration-200
        w-full md:w-auto
        cursor-pointer
        no-underline
        ${className}
      `} data-id="element-572">
      <span data-id="element-573">{children}</span>
      {showArrow && <ArrowRightIcon className="w-5 h-5" data-id="element-574" />}
    </motion.a>;
}